import type {
  NewStatusComponentStatus,
  NewStatusIncidentStatus
} from "./types";

export const EXCLUDED_INCIDENT_STATUSES: ReadonlySet<string> =
  new Set<NewStatusIncidentStatus>(["resolved", "postmortem"]);

export const COMPONENT_SEVERITY: Readonly<
  Record<NewStatusComponentStatus, number>
> = {
  operational: 0,
  degraded_performance: 1,
  partial_outage: 2,
  major_outage: 3
};
